import { PublicCompany } from '../companies/public-company';
import { InvitedExistingCompanyData } from './invited-existing-company-data';
import { InvitedExistingUserData } from './invited-existing-user-data';

export class PublicInviteCompanyForNetworkTicket {
	public Id: string;
	public IsExpired: boolean;
	public InvitationId: string;
	public Token: string;
	public InvitingCompanyId: string;
	public ExpirationDate: Date;
	public TokenUsed: boolean;
	public CompanyInviteType: string;
	public CreatedOn: Date;
	public CreatedBy: string;
	public InvitedCompanyName: string;
	public InvitedCompanyVatNumber: string;
	public InvitedCompanyCountryCode: string;
	public InvitedCompanyLanguageCode: string;
	public InvitedCompanyTimeZone: string;
	public InvitedEmail: string;
	public InvitedUserName?: string;
	public InvitedUserRole: string;
	public InvitingUsername?: string;
	public InvolvedContractId: string;
	public InvitedCompanyIBAN: string;
	public InvitedCompanySWIFT: string;
	public InvitingCompany: PublicCompany;
	public InvitationStatus: string;
	public InvitedExistingCompany: InvitedExistingCompanyData;
	public LegalDocumentsLanguageCode: string;
	public InvitedExistingUser: InvitedExistingUserData;
}
